import { useState } from "react";
import RequestForm from "@/components/RequestForm";
import Confirmation from "@/components/Confirmation";
import { PageHead, SButton } from "@/components/staff/Bits";

const TYPES = { assistance: "Assistance", talk: "Pastoral conversation", home_visit: "Home visit" };

export default function Intake() {
  const [type, setType] = useState("assistance");
  const [result, setResult] = useState(null);
  const [k, setK] = useState(0);
  if (result) return (
    <div className="max-w-3xl">
      <Confirmation result={result} office />
      <SButton className="mt-6" variant="ghost" data-testid="new-intake-again" onClick={() => { setResult(null); setK(k + 1); }}>Enter another request</SButton>
    </div>
  );
  return (
    <div className="max-w-3xl">
      <PageHead title="Office intake" sub="Enter a request on behalf of someone who cannot use a phone or computer. Read the privacy notice to them and record only what they agree to share." />
      <div className="flex flex-wrap gap-2 mb-8">
        {Object.entries(TYPES).map(([key, v]) => <SButton key={key} variant={type === key ? "primary" : "ghost"} data-testid={`intake-type-${key}`} onClick={() => { setType(key); setK(k + 1); }}>{v}</SButton>)}
      </div>
      <RequestForm key={`${type}-${k}`} type={type} endpoint="/cases/intake" onDone={setResult} />
    </div>
  );
}
